module.exports = __webpack_public_path__ + "img/agency1_logo.55bb780d.png";